import FieldGuideWire from './FieldGuideWire'

export default function StepLayout({ question, helper, aside, children, className }) {
  const cls = 'step-col' + (className ? ' ' + className : '')
  return (
    <div className={cls}>
      <FieldGuideWire />
      {(question || helper || aside) && (
        <header className="step-head">
          {question && <h1 className="step-heading">{question}</h1>}
          {helper && <p className="step-helper">{helper}</p>}
          {aside}
        </header>
      )}
      <div className="step-workbench">{children}</div>
    </div>
  )
}
